import React, { Component } from "react";
import { DownloadTableExcel } from "react-export-table-to-excel";
import {
  profile,
  branch,
  alert,
  total,
  float,
  toFixed,
  format_date,
  random_charactor,
  GET,
  POST,
  PUT,
  DELETE,
  loading,
  Status,
  params,
  required,
  DatePicker,
  Select,
  BtnIcon,
  Swal,
  Pagination,
  Switch,
  Navbar,
  Modal,
  Resizer,
} from "../../../components/CustomComponent.js";
import {reports} from "../../../components/Report.js";
export default class DebtReduces extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_create: false,

      filter_search: "",
      filter_start_date: format_date(
        new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          new Date().getDate() - 1
        ),
        "yyyy-mm-dd",
        "en"
      ),
      filter_end_date: format_date(new Date(), "yyyy-mm-dd", "en"),
      filter_warehouse_id: "",

      data: [],
      data_customer: [],
      data_invoice: [],
      data_warehouse: [],
      count: 10,

      id: "",
      uid: "",
      bank_name: "",
      account_number: "",
      account_name: "",
      customer_id: "",
    };
    this.tableRef = React.createRef();
  }

  async componentDidMount() {
    loading(false);
    await this.Get(1);
  }
  Get = async (page) => {
    const {
      filter_search,
      filter_start_date,
      filter_end_date,
      filter_warehouse_id,
    } = this.state;
    let data, count, data_customer, data_warehouse;
    loading(true);
    let [result, result_customer, result_warehouse] = await Promise.all([
      GET("admin/credit-notes/list", {
        page: 0,
        page_size: 10000,
        data_search: filter_search,
        start_date: filter_start_date
          ? format_date(filter_start_date, "yyyy-mm-dd", "en")
          : "",
        end_date: filter_end_date
          ? format_date(filter_end_date, "yyyy-mm-dd", "en")
          : "",
      }),
      GET("admin/setting/customers/list", { page: 0, data_search: "" }),
      GET("admin/setting/warehouses/list", { page: 0, data_search: "" }),
    ]);
    if (result?.status) {
      data = result.data;
      data = data.filter(
        (e, i) =>
          e.transaction_credit_note.filter(
            (t) => t.warehouse_id == filter_warehouse_id
          ).length !== 0 || !filter_warehouse_id
      );
    }
    if (result_customer?.status) {
      data_customer = result_customer.data.map((e) => ({
        value: e.uid,
        label: `${e.full_name}${e.customer_code ? ` ${e.customer_code} | ` : ""}${e.phone ? ` (${e.phone}) ` : ""} ${
            e.address ? ` | ${e.address}` : ""
          }`,
      }));
    }
    if (result_warehouse?.status) {
      data_warehouse = result_warehouse.data.map((e) => ({
        value: e.id,
        label: e.name,
      }));
    }
    this.setState({
      data,
      count,
      data_customer,
      data_warehouse,
    });
    loading(false);
  };


  ExportPDF = async () => {
    const table = this.tableRef.current;
    if (!table) return [];

    const rows = Array.from(table.querySelectorAll("tbody tr"));

    const data_list = rows.map((tr) => {
      const cells = Array.from(tr.querySelectorAll("td"));
      return cells.map((td) => td.innerText.trim());
    });

    const obj = {
          table: {
            headerRows: 0,
            widths: ["auto","auto","*","auto","auto","auto","auto"],
            body: [
              [
                { text: "วันที่", alignment: "center" },
                { text: "เลขที่ใบลดหนี้", alignment: "center" },
                { text: "เลขที่ใบแจ้งหนี้", alignment: "left" },
                { text: "ชื่อลูกค้า", alignment: "center" },
                { text: "สาเหตุคืน", alignment: "center" },
                "",
                "",
              ],
              ...data_list.map((item, index) => {
                let border = [1, 0, 1, 0];let color = "#ffffff";
                if(index === data_list.length - 1){
                  border = [1, 0, 1, 1];
                }
                if(item[0]){
                  border = !item[0].includes("ลำดับ") ? [0, 0, 0, 0]: [1, 1, 1, 1];
                  color = data_list[index+1].includes("ลำดับ") ? "#d8d8d8": "#ffffff";
                  return [
                      { text: item[0], alignment: "center", fillColor: color, border: [1, border[1], border[2], border[3]] },
                      { text: item[1], alignment: "center", fillColor: color, border },
                      { text: item[2], alignment: "left", fillColor: color, border },
                      { text: item[3], alignment: "center", fillColor: color, border },
                      { text: item[4], alignment: "center", fillColor: color, border },
                      { text: item[5], alignment: "right", fillColor: color, border },
                      { text: item[6], alignment: "right", fillColor: color, border: [border[0], border[1], 1, border[3]] },
                    ]
                }
                else{
                   border = [1, 1, 1, 1];
                  return [
                    { text: item[5], alignment: "right", colSpan: 6, border },
                    "",
                    "",
                    "",
                    "",
                    "",
                    { text: item[6], alignment: "right", border },
                  ]}
                }
            ),
            ],
          },
        };
    reports("รายงานใบลดหนี้", obj, 12, "portrait");
  }

  render() {
    const {
      modal_create,
      filter_search,
      filter_start_date,
      filter_end_date,
      filter_warehouse_id,
      data,
      data_customer,
      data_invoice,
      data_warehouse,
      count,
      id,
      uid,
      bank_name,
      account_number,
      account_name,
      customer_id,
    } = this.state;
    return (
      <div className="w-100 min-vh-100">
        <Navbar />
        <div className="body p-3">
          <div className="rounded-4 bg-white p-3">
            <div className="d-flex justify-content-between">
              <h4 className="fw-bold mb-3 me-3">ใบลดหนี้</h4>

              <button
                className="btn btn-dark px-4 mb-3"
                onClick={() => {
                  window.location.href = "/invoice/payment-debt-reduces";
                }}
              >
                สร้างใบลดหนี้
              </button>
            </div>
            <div className="d-flex flex-wrap align-items-center">
              <input
                type="text"
                className="form-control wpx-200 me-2 mb-2"
                placeholder="ค้นหา..."
                onChange={(e) => {
                  this.setState({ filter_search: e.target.value });
                }}
                onKeyUp={(e) => {
                  if (e.key === "Enter") {
                    this.Get(1);
                  }
                }}
                value={filter_search}
              />
              <input
                type="date"
                className="form-control wpx-200 me-2 mb-2"
                onChange={(e) => {
                  this.setState({ filter_start_date: e.target.value });
                }}
                value={filter_start_date}
              />
              <span className="px-2 me-2 mb-2">ถึง</span>
              <input
                type="date"
                className="form-control wpx-200 me-2 mb-2"
                onChange={(e) => {
                  this.setState({ filter_end_date: e.target.value });
                }}
                value={filter_end_date}
              />
              <div className="wpx-200 me-2 mb-2">
                <Select
                  className="form-control"
                  placeholder="คลังสินค้า..."
                  options={data_warehouse}
                  onChange={(e) => {
                    this.setState({ filter_warehouse_id: e });
                  }}
                  value={filter_warehouse_id}
                />
              </div>
              <div className="d-flex">
                <button
                  className="btn btn-dark px-3 me-2 mb-2"
                  onClick={() => {
                    this.Get(1);
                  }}
                >
                  ค้นหา
                </button>
                <button
                  className="btn btn-outline-dark px-3 me-2 mb-2"
                  onClick={() => {
                    window.location.reload();
                  }}
                >
                  ล้างค่า
                </button>
              </div>

              <div className="ms-auto">
                <button className="btn btn-warning px-3 mb-2 me-2" onClick={()=>this.ExportPDF()}>Export PDF</button>
                <DownloadTableExcel
                  filename="ใบลดหนี้"
                  sheet="ใบลดหนี้"
                  currentTableRef={this.tableRef.current}
                >
                  <button className="btn btn-warning px-3 mb-2">Excel</button>
                </DownloadTableExcel>
              </div>
            </div>
          </div>

          <div className="table-responsive" style={{maxHeight:"70vh"}}>
            <table
              className="table rounded-3 overflow-hidden table-hover"
              ref={this.tableRef}
            >
              <thead>
                <tr>
                  <td className="text-nowrap">วันที่</td>
                  <td className="text-nowrap">เลขที่ใบลดหนี้</td>
                  <td className="text-nowrap">เลขที่ใบแจ้งหนี้</td>
                  <td className="text-nowrap">ชื่อลูกค้า</td>
                  <td className="text-nowrap">สาเหตุคืน</td>
                  <td></td>
                  <td></td>
                </tr>
              </thead>
              <tbody>
                {data?.map((item, index) => (
                  <>
                    <tr>
                      <td className="text-nowrap bg-primary-light">
                        {item.created_at ? format_date(item.created_at) : ""}
                      </td>
                      <td className="text-nowrap bg-primary-light">
                        {item.document_no || ""}
                      </td>
                      <td className="text-nowrap bg-primary-light">
                        {item?.invoice?.sale?.document_no || "-"}
                      </td>
                      <td className="text-nowrap bg-primary-light">
                        {item.invoice?.sale?.customer?.full_name || "-"}
                      </td>
                      <td className="text-nowrap bg-primary-light">
                        {item.reason}
                      </td>
                      <td className="bg-primary-light"></td>
                      <td className="bg-primary-light"></td>
                    </tr>
                    <tr>
                      <td className="text-nowrap fw-bold">ลำดับ</td>
                      <td className="text-nowrap fw-bold">รหัสสินค้า</td>
                      <td className="text-nowrap fw-bold">ชื่อสินค้า</td>
                      <td className="text-nowrap fw-bold text-end">จำนวน</td>
                      <td className="text-nowrap fw-bold">หน่วย</td>
                      <td className="text-nowrap fw-bold text-end">ราคาต่อหน่วย</td>
                      <td className="text-nowrap fw-bold text-end">มูลค่ารวมทั้งสิ้น</td>
                    </tr>

                    {item.transaction_credit_note?.map((tx, tx_index) => (
                      <tr>
                        <td className="text-nowrap">{tx_index + 1}</td>
                        <td className="text-nowrap">
                          {tx.product_code || "-"}
                        </td>
                        <td className="text-nowrap">
                          {tx.product_name || "-"}
                        </td>
                        <td className="text-nowrap text-end">
                          {tx.qty || "0"}
                        </td>
                        <td className="text-nowrap">{tx.unit_name || "-"}</td>
                        <td className="text-nowrap text-end">
                          {tx.unit_price || "-"}
                        </td>
                        <td className="text-nowrap text-end">
                          {tx.amount || "-"}
                        </td>
                      </tr>
                    ))}
                    <tr className="fw-bold">
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td className="text-nowrap text-end">
                        จำนวนเงินทั้งสิ้น
                      </td>
                      <td className="text-nowrap text-end">
                        {toFixed(total(item.transaction_credit_note, "amount"))}
                      </td>
                    </tr>
                  </>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}
